<template>
<div>
  <div class="tabs">
    <ul>
      <router-link exact tag="li" :to="{ 
          name: 'section-manager', 
          params: { 
            standard: $route.params.standard,
            section: $route.params.section,
          }
        }">
        <a>Checkpoints</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'edit-section', params: { 
            standard: $route.params.standard,
            section: $route.params.section,
          }}">
        <a>Edit</a>
      </router-link>
    </ul>
  </div>
  <router-view />
</div> 
</template>
<script>
export default {
  beforeCreate() {
    this.$store.dispatch('standardSection/loadSection', this.$route.params.section)
  }
}
</script>